<template>
  <aha-modal @hide="hide()" title="Remove confirmation">
    <div :inner-html.prop="modalContent" />
    <div class="pl-4 mt-2 overflow-auto max-h-24" v-if="folder.presentations.length">
      <ul class="list-disc">
        <li
          v-for="(presn, presnIndex) in folder.presentations"
          :key="presnIndex"
        >
          {{ presn.name }}
        </li>
      </ul>
    </div>
    <template #action>
      <aha-button
        variant="danger"
        :disabled="isDeletingFolder"
        @click="handleDeleteFolder()"
        icon-name="delete"
        :submitting="isDeletingFolder"
        has-margin-right
      >
        <aha-spinner variant="white" class="mr-1" v-if="isDeletingFolder" />
        Remove
      </aha-button>
      <aha-link @click="hide()">
        <span class="font-bold">Cancel</span>
      </aha-link>
    </template>
  </aha-modal>
</template>
<script>
import { mapState, mapActions } from 'vuex'

// api
import FolderApi from '@/api/folder'

// constants
import gaCategories from '@/constant/gaCategories'
import constants from '@/constant'

// utils
import utils from '@/util'

export default {
  props: {
    folder: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      isDeletingFolder: false,
      modalContent: '',
    }
  },
  computed: {
    ...mapState({
      folders: (state) => state.folders,
    }),
  },
  mounted() {
    this.generateModalContent()
  },
  methods: {
    ...mapActions([
      'setFoldersAction',
      'setErrorOnInternalServerAction',
    ]),
    generateModalContent() {
      const mainContent =
      `Are you sure you want to remove this folder 
      <span class="font-bold break-words"> ${this.folder.folderName}</span>?
      `
      let moreContent = '<p>It contains no presentation.</p>'
      const numberOfPresn = this.folder.presentations.length
      if (numberOfPresn === 1) {
        moreContent = '<p>It contains 1 presentation:</p>'
      } else if (numberOfPresn > 1) {
        moreContent = `<p>It contains ${numberOfPresn} presentations:</p>`
      }
      this.modalContent = mainContent + moreContent
    },
    handlAfterCallAPIDeleteFolder(folderId) {
      utils.showToastSuccess(`Deleted folder "${this.folder.folderName}"`)
      utils.gaTrackEvent(gaCategories.PRESENTATION_LIST, 'Folder Kebab Menu > Delete Folder > Succeeded', null, null, {
        isTeamFolder: this.$store.state.workingMode === constants.workspace.TEAM,
        isSelfCreatedTeam: this.$store.state.currentAccount.createdFrom === 'presenter',
        role: this.$store.state.currentUser.accountRole || null,
        folderId: folderId || null,
        teamId: this.$store.state.currentAccount.id,
      })
      const index = this.folders.findIndex((folder) => {
        return folder.folderId === this.folder.folderId
      })
      this.folders.splice(index, 1)
      this.setFoldersAction(this.folders)
    },
    async handleDeleteFolder() {
      this.isDeletingFolder = true
      utils.gaTrackEvent(gaCategories.PRESENTATION_LIST, 'Folder Kebab Menu > Delete Folder > Submit')
      try {
        await FolderApi.removeFolderById(this.folder.folderId)
        this.handlAfterCallAPIDeleteFolder(this.folder.folderId)
      } catch {
        utils.gaTrackEvent(gaCategories.PRESENTATION_LIST, 'Folder Kebab Menu > Delete Folder > Failed')
        this.setErrorOnInternalServerAction(`Cannot delete folder ${this.folder.folderName}`)
      } finally {
        this.isDeletingFolder = false
        this.hide()
      }
    },
    hide() {
      this.$emit('hide')
    },
  },
}
</script>
